import React from 'react';
import OwlCarousel from 'react-owl-carousel';
const options = {
    margin: 90,
    responsiveClass: true,
    nav: false,
    dots: false,
    loop:true,
    autoplay: true,
    center:true,
    autoplayTimeout:5000,
    smartSpeed: 500,
    responsive: {
        0: {
            items: 1,
            margin: 30,
            center:false,
        },
        400: {
            items: 1,
            margin: 30,
            center:false,
        },
        600: {
            items: 2,
            margin: 30,
            center:false,
        },
        992: {
            items: 2,
            margin: 30,
            center:false,
        },
        1000: {
            items: 3,
 
        }
    },
 };
function Archievements(){
    return <>
    <OwlCarousel className='owl-theme our-archievements' {...options}> 
            <div className="item">
            <div className='Item_Box'>
            <div className='Heading'><span>Projekt</span> "Whatever"</div>
            <div className='Text'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. </div>    
            </div>    
            </div>

            <div className="item">
            <div className='Item_Box'>
            <div className='Heading'><span>Projekt</span> "Something"</div>
            <div className='Text'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.</div>    
            </div>    
            </div>  

            <div className="item">
            <div className='Item_Box'>
            <div className='Heading'><span>Projekt</span> "No Idea"</div>
            <div className='Text'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. </div>    
            </div>    
            </div>     
    </OwlCarousel>
    </>
}
export default Archievements;